import { CreateChapterDto } from '../../../interfaces/chapters.interface';
import { Question } from '../../../interfaces/questions.interface';

const generateDummyQuestion = (): Omit<Question, '_id' | 'chapter'> => {
  const categories = ['Road Signs', 'Traffic Rules', 'Vehicle Safety', 'Emergency Procedures'];
  const randomCategory = categories[Math.floor(Math.random() * categories.length)];
  
  const questionNumber = Math.floor(Math.random() * 10000);
  
  return {
    questionAnnouncement: `Sample Question ${questionNumber}: What should a driver do in this situation?`,
    category: randomCategory,
    answerA: `Option A for question ${questionNumber}`,
    answerB: `Option B for question ${questionNumber}`,
    answerC: `Option C for question ${questionNumber}`,
    answerD: `Option D for question ${questionNumber}`,
    correctAnswers: ['A', 'B'].slice(0, Math.floor(Math.random() * 2) + 1), // Randomly select 1 or 2 correct answers
    fileName: Math.random() > 0.5 ? `sample-image-${questionNumber}.jpg` : undefined
  };
};

const generateDummyChapter = (): CreateChapterDto => {
  const categories = ['Basic', 'Advanced', 'Professional', 'Safety'];
  const randomCategory = categories[Math.floor(Math.random() * categories.length)];
  const chapterNumber = Math.floor(Math.random() * 10000) + 1;
  
  return {
    title: `Chapter ${chapterNumber}: ${randomCategory} Driving Skills`,
    category: randomCategory,
    description: `This chapter covers essential ${randomCategory.toLowerCase()} driving skills and knowledge required for professional drivers. It includes comprehensive information about safety procedures, regulations, and best practices.`,
    questions: Array(3).fill(null).map(() => generateDummyQuestion())
  };
};

export const initialValues: CreateChapterDto = 
  process.env.NODE_ENV === 'development' 
    ? generateDummyChapter()
    : {
        title: '',
        category: '',
        description: '',
        questions: []
      };
